import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MainLayout from 'layout/MainLayout';

// loading option 1 routing
const Social = Loadable(lazy(() => import('views/contact/social')));

// ==============================|| LOADING ROUTING ||============================== //

const LoadingRoutes = {
    path: '/',
    element: <MainLayout />,
    children: [
        {
            path: '*',
            element: <Social />
        }
    ]
};

export default LoadingRoutes;
